<template>
  <div class="wa-frame">
    <div class="wa-frame__topbar">
      <v-icon x-small color="white" class="mr-1">mdi-whatsapp</v-icon>
      <span class="wa-frame__title">WhatsApp</span>
    </div>

    <div class="wa-frame__chat">
      <div class="wa-bubble">
        <div v-if="headerText" class="wa-bubble__header">
          {{ headerText }}
        </div>

        <div v-if="imageUrl" class="wa-bubble__image">
          <v-img :src="imageUrl" height="120" cover class="rounded-lg" />
        </div>

        <div v-if="bodyHtml" class="wa-bubble__body" v-html="bodyHtml" />

        <div v-if="footer" class="wa-bubble__footer">
          {{ footer }}
        </div>

        <div v-if="buttons.length" class="wa-bubble__actions">
          <div
            v-for="(label, idx) in buttons"
            :key="'wa-btn-' + idx"
            class="wa-bubble__action"
          >
            <v-icon x-small color="primary" class="mr-1"
              >mdi-open-in-new</v-icon
            >
            {{ label }}
          </div>
        </div>

        <div class="wa-bubble__meta">
          <span class="wa-bubble__time">{{ timeLabel }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WhatsappPreview",
  props: {
    bodyHtml: { type: String, default: "" },
    footer: { type: String, default: null },
    imageUrl: { type: String, default: null },
    headerText: { type: String, default: null },
    buttons: { type: Array, default: () => [] },
  },
  computed: {
    timeLabel() {
      const now = new Date();
      return now.toLocaleTimeString("pt-BR", {
        hour: "2-digit",
        minute: "2-digit",
      });
    },
  },
};
</script>

<style scoped>
.wa-frame {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
  max-width: 280px;
}

.wa-frame__topbar {
  display: flex;
  align-items: center;
  background: #075e54;
  color: white;
  padding: 8px 12px;
  font-size: 0.8125rem;
  font-weight: 500;
}

.wa-frame__title {
  letter-spacing: 0.01em;
}

.wa-frame__chat {
  background: #ece5dd;
  background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23d4cdc4' fill-opacity='0.35'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  padding: 16px 12px;
  min-height: 140px;
}

.wa-bubble {
  position: relative;
  background: #fff;
  border-radius: 0 8px 8px 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
  max-width: 100%;
  overflow: hidden;
}

.wa-bubble::before {
  content: "";
  position: absolute;
  top: 0;
  left: -6px;
  width: 0;
  height: 0;
  border-top: 6px solid #fff;
  border-left: 6px solid transparent;
}

.wa-bubble__header {
  padding: 8px 10px 0;
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.3;
}

.wa-bubble__image {
  margin: 4px;
  background: #f0f0f0;
}

.wa-bubble__body {
  padding: 8px 10px 4px;
  font-size: 0.875rem;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;
}

.wa-bubble__body:first-child {
  padding-top: 10px;
}

.wa-bubble__footer {
  padding: 0 10px 6px;
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.45);
  line-height: 1.3;
}

.wa-bubble__actions {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.wa-bubble__action {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  font-size: 0.8125rem;
  color: #027eb5;
  font-weight: 500;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.wa-bubble__action:first-child {
  border-top: none;
}

.wa-bubble__meta {
  display: flex;
  justify-content: flex-end;
  padding: 0 8px 6px;
  margin-top: -2px;
}

.wa-bubble__time {
  font-size: 0.6875rem;
  color: rgba(0, 0, 0, 0.38);
}
</style>
